import { VALIDATION_MESSAGES } from '@/constants/validation';
import { bool, object, string } from 'yup';
import { isValidPhoneNumber } from "libphonenumber-js";
import CountryFlags from '../sign-up/components/CountryFlags';
import { PhoneHelper } from '@/common/PhoneHelper';

export type SignupFormData = {
	firstName: string;
	lastName: string;
	mobileNumberPrefix: string;
	mobileNumber: string;
	email: string;
	agree: boolean;
};

export const signupSchema = object({
	firstName: string().trim().required(VALIDATION_MESSAGES.required)
		.test('no-numbers', 'Names cannot contain numbers', function (value) {
			if (!value) return true; // Let required validation handle empty values
			return !/\d/.test(value);
		}),
	lastName: string().trim().required(VALIDATION_MESSAGES.required)
		.test('no-numbers', 'Names cannot contain numbers', function (value) {
			if (!value) return true; // Let required validation handle empty values
			return !/\d/.test(value);
		}),
	mobileNumberPrefix: string().trim().required(VALIDATION_MESSAGES.required),
	mobileNumber: string().trim().required(VALIDATION_MESSAGES.required)
		.test('is-valid-phone', 'Please enter a valid phone number', function (value) {
			if (!value) return true; // Let required validation handle empty values

			try {
				// Import the validation function

				// Get the country code from the form context
				const countryCode = this.parent.mobileNumberPrefix || 'PH'; // Default to PH if no prefix
				//const res = isValidPhoneNumber('8 (800) 555-35-35', 'RU');
				//console.log(dialCode + cleanValue);
				const prepared = PhoneHelper.preparePhoneNumber(value, countryCode);
				const res = isValidPhoneNumber(prepared, countryCode);
				return res;
			} catch (error) {
				// If validation fails, return false
				return false;
			}
		}),
	email: string()
		.trim()
		.email(VALIDATION_MESSAGES.email)
		.required(VALIDATION_MESSAGES.required),
	agree: bool()
		.required(VALIDATION_MESSAGES.required)
		.oneOf([true], VALIDATION_MESSAGES.requiredShort),
});

export const signupInitialValues = {
	firstName: '',
	lastName: '',
	mobileNumberPrefix: '+63',
	mobileNumber: '',
	email: '',
	agree: false,
};
